<template>
  <div class="fl">
    <div class="fl m-r-20" :class="nocustom ? '' : 'radio-group-nobg'" style="margin-top: -1px;">
      <el-radio-group v-model="tagId" text-color="#b3b3b3" size="small">
        <el-radio-button :label="item.value" v-for="(item, index) in dateOptions" :key="index">{{item.name}}</el-radio-button>
      </el-radio-group>
    </div>
    <div class="fl" :class="nocustom ? '' : 'radio-dates-picker-nobg'">
      <mini-dates-picker v-model="dates" size="small"></mini-dates-picker>
    </div>
  </div>
</template>
<script>
export default {
  name: 'compositeDate',
  props: [
    'tag',
    'options',
    'date',
    'nocustom'
  ],
  data () {
    return {
      tagId: this.tag || '',
      dates: this.date || [],
      dateOptions: this.options || [
        {
          name: '最近30天',
          value: '30'
        },
        {
          name: '最近7天',
          value: '7'
        },
        {
          name: '昨天',
          value: '1'
        },
        {
          name: '今天',
          value: '0'
        }
      ],
      tagChange: !!this.tag
    }
  },
  watch: {
    'tagId': function (val) {
      if (this.tagId !== '') {
        this.getDate(val)
      }
    },
    'dates': function (val) {
      if (!this.tagChange) {
        this.tagId = ''
      }
      this.tagChange = false
      this.$emit('change', val)
    }
  },
  methods: {
    getDate (val) {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * Number(val))
      if (val !== '0') {
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
      }
      const dateStringArr = [
        this.util.getDateString(start),
        this.util.getDateString(end)
      ]
      this.tagChange = true
      this.dates = dateStringArr
    }
  },
  created () {
  },
  mounted () {
    if (this.tagId !== '') {
      this.getDate(this.tagId)
    }
  }
}
</script>
<style scoped>
</style>
